import "core-js/modules/es.string.link.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "siwper-template1"
  }, [_vm.formData.pathLink.length == 0 ? _c("img", {
    style: {
      height: _vm.formData.pcHeight + "px",
      width: "100%",
      objectFit: "contain"
    },
    attrs: {
      src: _vm.noImg,
      alt: ""
    }
  }) : _c("div", {
    staticClass: "swiper"
  }, [_c("YYCarousel", {
    key: _vm.formData.vertical,
    staticClass: "swapper_bg",
    attrs: {
      height: _vm.formData.mHeight + "px",
      direction: _vm.formData.vertical ? "vertical" : "horizontal",
      autoplay: _vm.formData.autoPlay,
      navigation: false,
      interval: _vm.formData.autoPlayTime * 1000
    }
  }, _vm._l(_vm.formData.pathLink, function (item, index) {
    return _c("YYCarouselItem", {
      key: index
    }, [_c("YYImage", {
      staticClass: "yyImg lunbotu",
      attrs: {
        fit: "cover",
        lazy: false,
        src: _vm.imgHost + item.path
      },
      on: {
        click: function click($event) {
          return _vm.goToPage(item.link);
        }
      }
    }), item.link ? _c("a", {
      staticStyle: {
        display: "none"
      },
      attrs: {
        href: item.link
      }
    }) : _vm._e()], 1);
  }), 1)], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };